export function normalizeTicketNotes(publicNotes?: string | null): string {
  if (!publicNotes) return '';

  const seenLines = new Set<string>();

  return publicNotes
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter((line) => {
      if (!line || seenLines.has(line)) return false;

      seenLines.add(line);
      return true;
    })
    .join('\n');
}
